import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient();

queryClient.setDefaultOptions({
  ...queryClient.getDefaultOptions(),
  queries: {
    refetchOnWindowFocus: false,
    retry: 1,
    refetchInterval: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  },
});

export default queryClient;
